import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'workers',
    loadChildren: () => import('./pages/worker/list/list.module').then( m => m.WorkerListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'concrete',
    loadChildren: () => import('./pages/concrete/list/list.module').then( m => m.ConcreteListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'concrete/:id',
    loadChildren: () => import('./pages/concrete/detail/detail.module').then( m => m.ConcreteDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'material',
    loadChildren: () => import('./pages/material/list/list.module').then( m => m.MaterialListPageModule)
  },
  {
    path: 'material/:id',
    loadChildren: () => import('./pages/material/detail/detail.module').then( m => m.MaterialDetailPageModule)
  },
  {
    path: 'hauloff',
    loadChildren: () => import('./pages/hauloff/list/list.module').then( m => m.HauloffListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'hauloff/:id',
    loadChildren: () => import('./pages/hauloff/detail/detail.module').then( m => m.HauloffDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'equipment',
    loadChildren: () => import('./pages/equipment/list/list.module').then( m => m.EquipmentListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'equipment/:id',
    loadChildren: () => import('./pages/equipment/detail/detail.module').then( m => m.EquipmentDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'survey-list',
    loadChildren: () => import('./pages/survey/survey-list/survey-list.module').then( m => m.SurveyListPageModule)
  },
  {
    path: 'survey-detail',
    loadChildren: () => import('./pages/survey/survey-detail/survey-detail.module').then( m => m.SurveyDetailPageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./pages/reports/report/report.module').then( m => m.ReportPageModule)
  },
  {
    path: 'modal-popup',
    loadChildren: () => import('./shared/modal-popup/modal-popup.module').then( m => m.ModalPopupPageModule)
  },
  {
    path: 'bh/:id',
    loadChildren: () => import('./pages/bh/bh.module').then( m => m.BhPageModule)
  },
  {
    path: 'security',
    loadChildren: () => import('./pages/security/tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'schedule',
    loadChildren: () => import('./pages/schedule/schedule.module').then( m => m.SchedulePageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
